import { constants } from '@approvalmax/utils';
import * as Sentry from '@sentry/browser';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axios from 'axios';

export const appVersionQueryKey = 'appVersion';

export const useGetAppVersion = (queryOptions?: UseQueryOptions<string>) => {
    return useQuery<string>(
        [appVersionQueryKey],
        async () => {
            try {
                const { data } = await axios.get<{ version: string }>('/ping', {
                    withCredentials: true,
                    withXSRFToken: true,
                    headers: { 'Content-Type': 'application/json' },
                });

                return data?.version || '';
            } catch (error) {
                Sentry.captureException(error);

                throw new Error(error);
            }
        },
        {
            retry: 3,
            retryDelay: 10 * constants.time.secondsMs,
            ...queryOptions,
        }
    );
};
